/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { noopDetectorSync } from './NoopDetectorSync';
var NoopDetector = /** @class */ (function () {
    function NoopDetector() {
    }
    NoopDetector.prototype.detect = function () {
        return Promise.resolve(noopDetectorSync.detect());
    };
    return NoopDetector;
}());
export { NoopDetector };
export var noopDetector = new NoopDetector();
//# sourceMappingURL=NoopDetector.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@opentelemetry/resources/build/esm/detectors/NoopDetector.js
// module id = 374
// module chunks = 0